<script>
	import Layout from '../../layouts/default/index.svelte'
	import userStore from '../../store/user/user'
	import Input from '../../components/input/input.svelte'
	import Button from '../../components/button/button.svelte'
	import RoundInfoIco from '../../components/icons/round-info.svelte'

	let username = ''
	let password = ''
	let user = {}

	userStore.subscribe(value => {
        user = value
    })

	function login() {
	    userStore.login({
            username,
            password
        })
	}
</script>

<style lang="scss">
	.content {
		max-width: 590px;
		padding: 0 20px;
		margin: 0 auto;
		text-align: center;
	}
	h1 {
		font-family: 'Roboto', sans-serif;
		font-weight: 100;
		line-height: 52px;
		font-size: 48px;
		margin-top: 111px;
		text-align: center;
		padding: 0 50px;
		margin-bottom: 80px;
	}
	.input-wrapper {
		margin-bottom: 24px;
	}
	label {
		text-align: left;
		font-family: Roboto;
		font-size: 14px;
		font-weight: bold;
		font-style: normal;
		font-stretch: normal;
		line-height: normal;
		letter-spacing: 1px;
		color: #c8c4c4;
		margin-bottom: 16px;
	}
	.submit-wrapper {
		text-align: right;
	}
	.message {
        font-family: Roboto;
        font-weight: 300;
        font-size: 15px;
        color: #FFFFFF;
        letter-spacing: 0.2px;
        line-height: 25px;
        position: relative;
        text-align: center;
        .ico {
            display: inline-block;
            vertical-align: top;
            padding-right: 5px;
        }
    }
	.contact-us {
		text-align: left;
		padding: 40px 0 0;
		 font-family: Roboto;
		font-weight: 300;
		font-size: 15px;
		color: #808683;
		letter-spacing: 0.17px;
		a {
			color: #DF4937;
		}
	}
</style>

<Layout>
	<div class="login">
		<h1>Login</h1>
		<div class="content">
		    {#if user.errorLoginStatus === 401}
		    <div class="message">
                <div class="ico">
                    <RoundInfoIco />
                </div>
                Wrong username or password
            </div>
            {/if}
			<div class="input-wrapper">
				<label for="login-username">Username</label>
				<Input id="login-username" type="text" size="big" placeholder="Username" on:change="{(ev) => username=ev.target.value}" />
			</div>
			<div class="input-wrapper">
				<label for="login-password">Password</label>
				<Input id="login-password" type="password" size="big" placeholder="Password" on:change="{(ev) => password=ev.target.value}" />
			</div>
			<div class="submit-wrapper">
				<Button width="200px" on:click={login} text="Login"/>
			</div>
			<p class="contact-us">To get a free testing account, send us an e-mail to <a href="mailto:contact@blindspot.ai">contact@blindspot.ai</a>.</p>
		</div>
	</div>
</Layout>


